import React from 'react'
import Button, { ButtonProps } from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'

type LoaderButtonProps = Omit<ButtonProps, 'endIcon'> & {
  loading: boolean
}

const LoaderButton = withStyles((theme) => ({}))(
  ({ loading, ...props }: LoaderButtonProps) => (
    <Button
      endIcon={loading && <CircularProgress color="inherit" size="1em" />}
      {...props}
    />
  )
)

export default LoaderButton
